import { apiClient } from 'apiClient';

const getFileLink = async (id: number): Promise<string | undefined> => {
  const response = await apiClient.get(`/v1/files/${id}`);
  return response.data?.link;
};

export const FilesApi = { getFileLink };
